import { render } from "./HeroFilter.vue?vue&type=template&id=f9f30a20&scoped=true"
import script from "./HeroFilter.vue?vue&type=script&lang=js"
export * from "./HeroFilter.vue?vue&type=script&lang=js"

import "./HeroFilter.vue?vue&type=style&index=0&id=f9f30a20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f30a20"]])

export default __exports__